<template>
  <div class="forget">
    <!-- pc端头部 -->
    <house-pc-header class="forget_pc_header">
      <span>{{ lang.userSetLang }}</span>
    </house-pc-header>
    <div class="forget_pc_block">
      <!-- wap端头部 -->
      <house-wap-header class="forget_wap_header">
        <span>{{ lang.resetWayLang }}</span>
      </house-wap-header>
      <!-- pc进度条 -->
      <div class="forget_pc_bar">
        <progress-bar step="1" />
      </div>
      <p class="forget_pc_way">
        {{ lang.resetWayLang }}
      </p>
      <van-tabs
        v-model="active"
        :line-width="80"
        title-inactive-color="#333"
        title-active-color="#ed1c24"
        @click="cutoverTab"
      >
        <van-tab :title="lang.telLang">
          <house-form
            ref="form"
            :type="'forget'"
            :active="1"
            :model="forget"
            :error="error"
            class="forget_wap_form forget_pc_form"
          >
            <house-form-item class="forget_wap_form_item forget_pc_form_item">
              <house-select
                v-model="forget.check"
                :options="options"
                placeholder="852"
              />
              <house-input
                v-model.trim="forget.telephone"
                type="text"
                :placeholder="lang.telPointLang"
                :del-btn="forget.telephone"
                @del="del('telephone')"
              />
            </house-form-item>
            <house-form-item class="forget_wap_form_item forget_pc_form_item">
              <house-input
                v-model.trim="verifyCode"
                type="text"
                :placeholder="lang.ImgPointLang"
                maxlength="4"
              />
              <img
                :src="verifyImg"
                alt=""
                class="verifyImg"
                @click="loadImg"
              >
            </house-form-item>
            <house-form-item class="forget_wap_form_item forget_pc_form_item">
              <house-input
                v-model.trim="forget.code"
                type="text"
                :placeholder="lang.SMSPointLang"
                @keyupEnter="nextBtn('tel')"
              />
              <houseCode
                :user-input="forget"
                :verify-code="verifyCode"
                :verify-token="verifyToken"
                @end="endBackword"
                @refresh-captcha="loadImg"
                @click="getCode"
              />
            </house-form-item>
          </house-form>
          <div
            class="red_btn forget_wap_red_btn"
            :class="nextLightBtn ? 'red_active' : ''"
            @click="nextBtn('tel')"
          >
            {{ lang.nextLang }}
          </div>
        </van-tab>
        <van-tab :title="lang.emailLang">
          <house-form
            ref="form"
            :type="'forget'"
            :active="2"
            :model="forget"
            class="forget_wap_form forget_pc_form"
            :error="error"
          >
            <house-form-item class="forget_wap_form_item forget_pc_form_item">
              <house-input
                v-model.trim="forget.email"
                :placeholder="lang.emailPointLang"
                :del-btn="forget.email"
                @del="del('email')"
                @keyupEnter="nextBtn('email')"
              />
            </house-form-item>
          </house-form>
          <div
            class="red_btn forget_wap_red_btn"
            :class="nextLightBtn ? 'red_active' : ''"
            @click="nextBtn('email')"
          >
            {{ lang.continueLang }}
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <van-dialog
      v-model="emailSend"
      class="emailDialog"
      :confirm-button-text="lang.continueLang"
    >
      <div class="emailContent">
        {{ lang.emailSendlang }}
      </div>
    </van-dialog>
  </div>
</template>

<script>
import houseWapHeader from '../../components/houseLogin/houseWapHeader';
import progressBar from '../../components/houseLogin/progressBar';
import housePcHeader from '../../components/houseLogin/housePcHeader';
import houseForm from '../../components/houseLogin/houseForm';
import houseFormItem from '../../components/houseLogin/houseFormItem.vue';
import houseInput from '../../components/houseLogin/houseInput.vue';
import houseSelect from '../../components/houseLogin/houseSelect.vue';
import houseCode from '../../components/houseLogin/houseCode.vue';
import houseAgree from '../../components/houseLogin/houseAgree.vue';
import pub from '../../../common/public';
import lang from '../../../common/language/new_login';

export default {
  components: {
    houseForm,
    houseFormItem,
    houseInput,
    houseSelect,
    houseCode,
    houseWapHeader,
    houseAgree,
    housePcHeader,
    progressBar
  },
  data() {
    return {
      lang: lang,
      active: 0,
      forget: {
        telephone: '',
        code: '',
        email: '',
        check: '852'
      },
      options: [{ name: '853', id: '1' }, { name: '852', id: '2' }, { name: '86', id: '3' }],
      tabLogin: 'one', //切换登入,
      error: '', //错误信息
      switchCode: true, //验证码开关
      key: '',
      emailNum: true,
      emailSend: false,
      verifyImg: '', //验证图形
      verifyCode: '', //图形验证码
      verifyToken: '', //图形验证token
    };
  },
  computed: {
    nextLightBtn() {
      let { telephone, check, code, email } = this.forget;
      if ((telephone.length > 0 && code.length > 0) || email.length > 0) {
        return true;
      } 
        return false;
      
    },
    forgetTel() {
      return this.forget.telephone;
    },
    forgetEmail() {
      return this.forget.email;
    }
  },
  watch: {
    forget: {
      handler() {
        this.emailNum = true;
        let reg = /^[4,5,6,7,9]/;
        let result = pub.emailValidator(this.forgetEmail);
        if (!reg.test(this.forgetTel) && this.forgetTel) {
          this.error = this.lang.errTelFormLang;
        } else if (this.forgetEmail && result != 0) {
          this.error = this.lang.errEmailFormLang;
        } else {
          this.error = '';
        }
      },
      deep: true
    },
    verifyCode(value) {
      let reg = /^\d{4}$/;
      if (reg.test(value)) {this.error = '';}
    }
  },
  mounted() {
    let { type, key, email } = this.$route.query;
    console.log(type, key, email);
    if (type == 2) {
      this.active = 1;
      this.axios(pub.getApi().VerifyRetrievePasswordKey, {
        params: {
          key: key
        }
      }).then(res => {
        if (res.data.code == 0) {
          console.log('跳转成功！');
          this.$router.push(`/reset?key=${key}`);
        } else {
          console.log('跳转失败！');
          this.$nextTick(() => {
            this.error = this.lang.errNoEmailLang;
          });
        }
      });
    }
    this.loadImg();
  },
  methods: {
    /*—————— 公共功能 —————— */
    /* 删除输入框内容 */
    del(type) {
      this.forget[type] = '';
    },
    /* 验证码倒数回调 */
    endBackword(type) {
      this.switchCode = type;
      this.error = type;
    },
    /* 重置表单 */
    resetForm() {
      this.forget = {
        telephone: '',
        code: '',
        email: '',
        check: '852'
      };
      this.error = '';
    },
    /* 切换tab */
    cutoverTab() {
      if (this.type) {return;}
      this.resetForm();
    },
    /* 下一步 */
    nextBtn(type) {
      if (!this.nextLightBtn || this.error) {return;}
      console.log(1111111111);
      let { telephone, code, email, check } = this.forget;
      if (type == 'tel') {
        this.axios
          .post(pub.getApi().RetrievePasswordByPhone, {
            phone: telephone,
            phoneCode: check,
            captcha: code,
            verifyCode: this.verifyCode,
            verifyToken: this.verifyToken
          })
          .then(res => {
            console.log('密码找回手机', res);
            if (res.data.code == 0) {
              console.log('下一步');
              this.$router.push(`/reset?key=${res.data.result}`);
            } else if (res.data.code == 1319) {
              this.error = this.lang.SMSErrorLang;
            } else {
              this.error = this.lang.errNoTelLang;
            }
          });
      } else {
        if (!this.emailNum) {
          // this.$toast('请查看邮箱');
        } else {
          this.emailNum = false;
          this.axios
            .post(pub.getApi().RetrievePasswordByEmail, {
              email: email
            })
            .then(res => {
              console.log('密码找回邮箱', res);
              if (res.data.code == 0) {
                console.log('下一步');
                this.emailSend = true;
                // this.$toast(this.lang.emailSendlang);
              } else {
                this.error = this.lang.errNoEmailLang;
              }
            });
        }
      }
    },
    /*—————— 手提电话 ——————*/
    /*获取验证码*/
    getCode(error) {
      if(!this.verifyCode) {
        this.error = this.lang.ImgPointLang;
        return;
      }
      this.error = error;
    },
    /* 加载图形验证码 */
    loadImg() {
      this.axios(pub.getApi().GetRecaptcha).then((res) => {
        console.log('图片', res);
        if (res.data.code === 0) {
          this.verifyImg = 'data:image/png;base64,' + res.data.result.image;
          this.verifyToken = res.data.result.token;
        }
      });
    }
  }
};
</script>
<style>
.forget .van-tabs {
  margin-top: 50px;
}
</style>
<style lang="scss">
@import url('../../assets/base.css');
.forget {
  // height: 100%;
  padding: 0 15px;
  font-size: 14px;
  .forget_pc_block {
    width: auto;
  }
  .forget_wap_form {
    margin: 37px 0 35px;
  }
  .forget_wap_red_btn {
    font-size: 17px;
  }
  .forget_pc_header {
    display: none;
  }
  .forget_pc_bar {
    display: none;
  }
  .forget_wap_form_item {
    border-bottom: 1px solid #eee;
    .verifyImg {
      cursor: pointer;
      height: 30px;
      max-width: 120px;
    }
  }
  .forget_wap_form_item:hover {
    border-bottom: 1px solid red;
  }
  .forget_pc_way {
    display: none;
  }
  .emailDialog {
    width: 66%;
    .emailContent {
      padding: 45px 0;
    }
  }
}
@media screen and (min-width: 601px) {
  .forget {
    overflow: auto;
    background-color: #f4f4f4;
    height: 100%;
    padding: 0;
    .forget_pc_block {
      background-color: #fff;
      margin: 0 auto;
      margin-top: 40px;
      width: 1200px;
      // height: 100%;
      padding-bottom: 130px;
      font-size: 16px;
      display: flex;
      align-items: center;
      flex-direction: column;
    }
    .forget_wap_header {
      display: none;
    }
    .forget_pc_header {
      width: 100%;
      display: block;
      // position: absolute;
      top: 0;
    }
    .forget_pc_bar {
      display: block;
    }
    .forget_pc_way {
      display: block;
      padding: 30px 0 40px;
      color: #333333;
    }
    .forget_pc_form {
      // width: 400px;
      .forget_pc_form_item {
        width: 400px;
        border: 1px solid #e0e0e0;
      }
      .forget_pc_form_item:nth-of-type(1) {
        margin-bottom: 25px;
      }
      .forget_pc_form_item:nth-of-type(2) {
        margin-bottom: 25px;
      }
      .forget_pc_form_item:hover {
        border: 1px solid red;
      }
    }
    .emailDialog {
      width: 400px;
    }
  }
}
</style>
